<template>
    <svg class="icon" :style="{'font-size':fontSize,'background':background}" @click="onClick()">
        <use :xlink:href="'#icon-' + type"></use>
    </svg>
</template>

<script>
  import '../../assets/iconfont/iconfont.js';

  export default {
    props: {
      /**
       * 图标类型
       */
      type: String,
      /**
       * 图标背景颜色
       */
      background: String,
      /**
       * 图标大小
       */
      size: {
        type: [Number, String],
        default: 24
      }
    },
    computed: {
      fontSize() {
        var size = Number(this.size)
        size = isNaN(size) ? 24 : size
        return `${size}px`
      }
    },
    methods: {
      onClick() {
        this.$emit('click')
      }
    }
  }
</script>

<style>
    .icon {
        width: 1em; height: 1em;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
    }
</style>